export default {"src":"/_next/static/media/0xabddafb225e10b90d798bb8a886238fb835e2053.2e1b6b93.svg","height":129,"width":129,"blurWidth":0,"blurHeight":0};